import React, { FC } from 'react';
import classNames from 'classnames';

import getClassNames from 'src/common/utils/getClassNames';

import styles from './DlpLayout.module.scss';

export type DlpLayoutProps = {
  /**
   * Optional section background color
   */
  backgroundColor?: 'midnight01' | 'midnight02' | 'ivory' | 'bluminescence100';
  /**
   * The Dlp section to render.
   */
  children: React.ReactNode;
  /**
   * For href reference
   */
  id?: string;
};

const DlpLayout: FC<DlpLayoutProps> = ({
  backgroundColor,
  children,
  id,
}) => (
  <div
    className={getClassNames(styles, 'root', classNames(backgroundColor, {
      hasBackgroundColor: backgroundColor,
    }))}
    id={id}
  >
    <section className={styles.inner}>
      {children}
    </section>
  </div>
);

export default DlpLayout;
